import { render, staticRenderFns } from "./IconSvgTxt.vue?vue&type=template&id=4d0d4481&scoped=true&"
import script from "./IconSvgTxt.vue?vue&type=script&lang=js&"
export * from "./IconSvgTxt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0d4481",
  null
  
)

export default component.exports